import * as React from 'react';
import {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import {useLoaderData, useNavigate} from "react-router-dom";
import {Container, Divider, Stack} from "@mui/material";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import NewIcon from '@mui/icons-material/FiberNew';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import dragon from "../assets/dragon.jpg";
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import api from "../services/api";
import LoadingButton from "@mui/lab/LoadingButton";

export default function Game() {
    const game = useLoaderData();
    const [selectedPlayers, setSelectedPlayers] = useState([]);
    const [selectedCharacters, setSelectedCharacters] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const players = [
        ...game.available.players,
        {
            id: 'new',
            name: 'Invité',
            characters: []
        }
    ];
    const roles = game.available.roles;

    useEffect(() => {
        const ps = players
            .filter(player => game.characters.find(character => character.player_id === player.id))
        setSelectedPlayers(ps.map(player => player.id));

        const cs = [];
        ps.forEach((player, index) => {
            cs[index] = player.characters.find(character => game.characters.find(gc => gc.id === character.id))
        })
        setSelectedCharacters(cs)
    }, [game])

    const onPlayerChange = (playerId, index) => {
        let selected = [...selectedPlayers];
        selected[index] = playerId;
        setSelectedPlayers(selected);
    }

    const onCharacterChange = (value, index) => {
        let selected = [...selectedCharacters];
        selected[index] = value
        setSelectedCharacters(selected);
    }

    const playerTaken = (player) => player.id !== 'new' && !!selectedPlayers.find(selected => selected === player.id);
    const characterRoleTaken = (character, index) => {
        const sameCharacterRoleIndex = selectedCharacters
            .filter(selected => !selected.player_id)
            .findIndex(selectedRole => selectedRole.id === character.role_id)
        const sameRoleIndex = selectedCharacters
            .filter(selected => !!selected.player_id)
            .findIndex(selectedCharacter => selectedCharacter.role_id === character.role_id)

        return (sameRoleIndex !== -1 && sameRoleIndex !== index)
            || (sameCharacterRoleIndex !== -1 && sameCharacterRoleIndex !== index)
    }

    const roleTaken = (role, index) => {
        const sameRoleIndex = selectedCharacters
            .filter(selected => !selected.player_id)
            .findIndex(selectedRole => selectedRole.id === role.id)
        const sameCharacterRoleIndex = selectedCharacters
            .filter(selected => !!selected.player_id)
            .findIndex(selectedCharacter => selectedCharacter.role_id === role.id)

        return (sameRoleIndex !== -1 && sameRoleIndex !== index)
            || (sameCharacterRoleIndex !== -1 && sameCharacterRoleIndex !== index)
    }

    const save = () => {
        setLoading(true)
        api()
            .updateGame(game.id, {
                characters: selectedCharacters.map((character, index) => {
                    if (!character.player_id) {
                        return {
                            id: 0,
                            player_id: selectedPlayers[index],
                            role_id: character.id,
                            name: character.name
                        }
                    }

                    return {
                        id: character.id,
                        player_id: character.player_id,
                        role_id: character.role_id,
                        name: character.name
                    }
                })
            })
            .then(() => navigate('/adventures'))
            .finally(() => setLoading(false))
    }

    return (
        <>
            <img src={dragon} alt={'closed chest'} style={{ width: '100%', maxWidth: '500px' }}/>
            <Typography variant="h5" paragraph sx={{ mt: 2 }} color="text.primary">
                {game.adventure.name}
            </Typography>
            <Typography align="center" color="text.secondary" paragraph>
                {game.adventure.description}
            </Typography>
            {[...Array(game.adventure.seats).keys()].map(index =>
                <Container key={index}
                           sx={{
                               flexDirection: 'row',
                               display: 'flex',
                               justifyContent: "space-evenly"
                           }}>
                    <FormControl sx={{ m: 1, flex: 1 }}>
                        <InputLabel>Joueur</InputLabel>
                        <Select value={selectedPlayers[index] || ''} label="Joueur"
                                onChange={event => onPlayerChange(event.target.value, index)}>
                            {players.map(player =>
                                <MenuItem disabled={playerTaken(player, index)} key={player.id} value={player.id}>
                                    {player.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl sx={{ m: 1, flex: 1 }}>
                        <InputLabel sx={{ fontSize: 14 }}>Personnage</InputLabel>
                        <Select disabled={!selectedPlayers[index]} value={selectedCharacters[index] || ''}
                                label="Personnage"
                                onChange={event => onCharacterChange(event.target.value, index)}
                                sx={{ justifyContent: 'center' }}>
                            {!!players.find(player => player.id === selectedPlayers[index])
                                && players.find(player => player.id === selectedPlayers[index]).characters?.map(character =>
                                    <MenuItem key={character.id} value={character}
                                              disabled={characterRoleTaken(character, index)}>
                                        {character.name} (niv. 1)
                                    </MenuItem>)}
                            <Divider/>
                            {roles.map(role => <MenuItem sx={{ justifyContent: 'center' }} key={role.id}
                                                         value={role} disabled={roleTaken(role, index)}>
                                {role.name}<NewIcon sx={{ ml: 1 }}/></MenuItem>)}
                        </Select>
                    </FormControl>
                </Container>)}
            <Stack
                sx={{ pt: 2 }}
                direction="row"
                spacing={2}
                justifyContent="center"
            >
                <LoadingButton loading={loading} variant="contained" onClick={save}>
                    <SportsEsportsIcon sx={{ mr: 1 }}/> Sauvegarder
                </LoadingButton>
            </Stack>
        </>
    );
}
